/**
 * Reusable card + row pair for detail screens (Appointment, WO).
 * Matches `.detail-card` / `.card-row` / `.row-label` / `.row-value`
 * styling in the mockup. Kept pure-presentational so both contexts
 * compose the same primitives.
 */
import type { ReactNode } from 'react'
import { cn } from '@vollgas/shared/utils'

interface DetailCardProps {
  readonly label: string
  readonly children: ReactNode
  readonly className?: string
}

export function DetailCard({ label, children, className }: DetailCardProps) {
  return (
    <div className={cn('mb-3 rounded-md border border-glass-border bg-glass-fill p-px18', className)}>
      <div className="mb-px14 text-11 font-bold uppercase tracking-mk-up14 text-glass-text-muted">{label}</div>
      {children}
    </div>
  )
}

interface DetailRowProps {
  readonly label: string
  readonly children: ReactNode
  readonly mono?: boolean
}

export function DetailRow({ label, children, mono = false }: DetailRowProps) {
  return (
    <div className="flex items-center justify-between gap-3 border-t border-glass-divider py-px10 first:border-t-0">
      <span className="flex-shrink-0 text-xs text-glass-text-muted">{label}</span>
      <span
        className={cn(
          'text-right font-semibold text-glass-text',
          mono ? 'font-mono text-12 font-bold tracking-mk-p3' : 'text-13-5',
        )}
      >
        {children}
      </span>
    </div>
  )
}
